import styled from "styled-components";
import { baseColors } from "../../../../../../themes/definitions/si/cis/base-colors";
import { LiveCasinoGridDefaultBox } from "./live-casino-grid.default.box";

export const LiveCasinoGridCasinoSICisBox = styled(LiveCasinoGridDefaultBox)`
    background-color: ${baseColors.base07};
`;